<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
    name: 'single'
}
</script>

<style>

</style>